import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function ArticleSection() {
  const featuredArticles = articles.slice(0, 3);

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100/70">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2">精选尺码指南</h2>
            <p className="text-foreground-600 text-sm">最新最全的亚洲五码换算知识与选码技巧</p>
          </div>
          <Link
            to="/category/shoes"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer font-medium"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuredArticles.map((article) => (
            <ArticleCard key={article.id} {...article} />
          ))}
        </div>

        <Link
          to="/category/shoes"
          className="sm:hidden flex items-center justify-center gap-1 mt-8 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer font-medium"
        >
          查看全部文章 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}